module.exports = __webpack_public_path__ + "img/threeday1-1.217a4e6d.jpg";